
import { prop, Vue } from "vue-class-component";

class Props {
  loading = prop<boolean>({ default: false, type: Boolean });
}

export default class AddressSidebarPlaceholder extends Vue.with(Props) {}
